/* eslint-disable no-restricted-syntax */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

export enum IdentityEnum {
  VIP = 0,
  BD = 1,
  公会长 = 2,
  币商 = 3,
  活动 = 4,
}

export const getHoursMin = (sec) => {
  if (sec < 86400) {
    return `x${Math.floor(Math.max(0, sec) / 3600)}H`
  }
  const hour = Math.floor((sec % 86400) / 3600)
  const day = Math.floor(sec / 86400)
  return `x${day}D${hour <= 0 ? '' : `${hour}H`}`
}

export const get_privilege_box_choose_page = createAsyncThunk(
  'TreasureBox/get_privilege_box_choose_page',
  async (params: any, store: any) => {
    const {identity, activity_name} = store.getState().env.otherInfo
    const resp = await http.post(
      '/live/privilege/get_privilege_box_choose_page',
      {first_tab: identity, activity_name, ...params},
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const send_privilege_box = createAsyncThunk(
  'TreasureBox/send_privilege_box',
  async (params: any, store: any) => {
    const resp = await http.post('/live/privilege/send_privilege_box', params, {
      store,
      xcErrorToast: true,
    })
    return resp.data.data
  }
)

export const get_privilege_box_homepage = createAsyncThunk(
  'TreasureBox/get_privilege_box_homepage',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/privilege/get_privilege_box_homepage',
      params,
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

export interface InitialStateType {
  choose: {
    list: Array<any>
  }
  home: any
}

const initialState: InitialStateType = {
  choose: {
    list: [],
  },
  home: {},
}

export const TreasureBoxSlice = createSlice({
  name: 'TreasureBox',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      get_privilege_box_choose_page.fulfilled,
      (state, action) => {
        Object.assign(state.choose, action.payload)
      }
    )
    builder.addCase(get_privilege_box_homepage.fulfilled, (state, action) => {
      Object.assign(state.home, action.payload)
    })
  },
})
export default TreasureBoxSlice.reducer
export const TreasureBoxActions = TreasureBoxSlice.actions

export const useTreasureBoxState = () => {
  const data = useSelector((state) => {
    return state.Animal_Tiger
  })
  return data
}
